import type { ClientOverviewRepository } from "../repositories/ClientOverviewRepository";
import type { ExpenseBootstrapEntity } from "../entities/ExpenseBootstrapEntity";

export class GetExpenseBootstrapUseCase {
  constructor(private readonly repository: ClientOverviewRepository) {}

  async execute(): Promise<ExpenseBootstrapEntity> {
    return this.repository.getExpenseBootstrap();
  }
}
